module.exports = "/push-worker.js";